import { type FC, useEffect, useRef } from 'react'
import { getIncodeClient } from '@egw/risk-service'
import { Logger } from '@egw/logger'

const log = new Logger('DocV')

interface RetryStepsProps {
  session: { token: string }
  onSuccess: () => void
  onError: () => void
  numberOfTries: number
}

export const RetrySteps: FC<RetryStepsProps> = ({ session, onSuccess, onError, numberOfTries }) => {
  log.info('RetrySteps: Starting')

  const containerRef = useRef<HTMLDivElement>(null)
  const isMounted = useRef(false)

  useEffect(() => {
    if (isMounted.current || !session || !containerRef.current) {
      return
    }
    getIncodeClient().renderRetrySteps(
      containerRef.current,
      {
        token: session,
        numberOfTries,
        showPassport: true,
        idTimeout: 30000,
      },
      {
        onSuccess,
        onError,
      },
    )
    isMounted.current = true
  }, [onSuccess, onError, session, numberOfTries])

  return <div ref={containerRef} />
}
